import React, { Component } from 'react'
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";
import constants from "../../../common/constants.js";
import BrandList from "./BrandList.js"


class Brand extends Component {
  constructor() {
    super();
    this.state = {
      brands: []
    };

    this.updateBrandState = this.updateBrandState.bind(this);
    this.addBrand = this.addBrand.bind(this);
    this.removeBrand = this.removeBrand.bind(this);
    this.saveBrands = this.saveBrands.bind(this);
  }

  componentWillMount() {
    this.refreshBrandList();
  }

  refreshBrandList() {
    this.fetchBrandList((err, brands) => {
      if (err) return this.dialogs.error(err);

      this.setState({
        brands,
      });
    });
  }

  addBrand() {
    let brands = _.cloneDeep(this.state.brands);

    brands.push({
      name: {
        zhTW: '',
        en: '',
      },
      status: 'active',
      order: '',
    });

    this.setState({
      brands,
    });
  }

  removeBrand(index, event) {
    let brands = _.cloneDeep(this.state.brands);

    _.pullAt(brands, index);

    this.setState({
      brands,
    });
  }

  saveBrands(cb) {
    DataAPI.post('/api/adminPanel/brands', {
      brands: this.state.brands,
    }, (err, brands) => {
      if (err) return this.dialogs.error(err);

      this.dialogs.alert({
        title: '成功更新品牌',
      });
      this.refreshBrandList();
    });
  }

  fetchBrandList(cb) {
    DataAPI.get('/api/adminPanel/brands', {}, cb);
  }

  updateBrandState(index, field, value) {
    let brands = _.cloneDeep(this.state.brands);

    if (field === 'order' && value) {
      value = _.toNumber(value);
      if (!value) return;
    }
    _.set(brands[index], field, value);

    this.setState({
      brands,
    });
  }

  render() {
    return (
      <div>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle
              text="品牌管理" />
          </ToolbarGroup>
          <ToolbarGroup
            lastChild={true}>
            {/*<RaisedButton*/}
              {/*label="新增隊伍"*/}
              {/*primary={true}*/}
              {/*icon={<i className="material-icons md-light">add</i>}*/}
              {/*onClick={this.addBrand}*/}
              {/*disabled={_.size(this.state.brands) >= constants.maxNumberOfBrands} />*/}
          </ToolbarGroup>
        </Toolbar>
        <BrandList
          brands={this.state.brands}
          onChange={this.updateBrandState}
          onDelete={this.removeBrand} />
        <br />
        <RaisedButton
          label="儲存"
          primary={true}
          onClick={this.saveBrands} />
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Brand;


// WEBPACK FOOTER //
// client/adminPanel/panel/brands/Brand.js